import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const CircleStyled = styled(Box).attrs({
  mx: { sm: '300' },
})`
  ${({ theme }) => css`
    width: ${theme.spacings[100]};
    height: ${theme.spacings[100]};
    background-color: ${theme.colors.grey[500]};
    border-radius: ${theme.radii[900]};
  `}
`;
